import { TEXT_COLOURS, BRANDED_COLOURS, GRADIENTS, WA_BLACK, WA_TRANSPARANT } from '@constants';
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const MAX_IMAGES = 30;

export const FORM_FIELD_IMAGE = {
  IMAGE: {
    name: 'image',
    label: 'Image:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'Image is required' }],
    size: IMAGE_SIZE['2000x1333'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [...BRANDED_COLOURS, GRADIENTS['gradient-1'].key, GRADIENTS['gradient-3'].key],
    rules: [{ required: true, message: 'Background color is required' }],
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title for the image',
    rules: [{ required: true, message: 'Image title is required' }],
  },
  SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Enter a subtitle for the image',
    rules: [{ required: true, message: 'Image subtitle is required' }],
  },
  SUBTITLE_EDITED: {
    name: 'subtitleEdited',
    label: 'Subtitle:',
    placeholder: 'Enter a subtitle for the image',
    rules: [{ required: true, message: 'Image subtitle is required' }],
  },
};

export const IMAGES = {
  name: 'images',
  rules: [{ min: 1, max: 6 }],
};

export const FORM_FIELD = {
  IMAGES,
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_TRANSPARANT, WA_BLACK, ...BRANDED_COLOURS, GRADIENTS['gradient-1'].key],
    rules: [{ required: true }],
  },
  TEXT_COLOR: {
    name: 'textColour',
    label: 'Text colour:',
    colors: [...TEXT_COLOURS],
    rules: [{ required: true, message: 'Text color is required' }],
  },
  TITLE: {
    name: 'title',
    label: 'Gallery title:',
    placeholder: 'Enter a title for the gallery',
    rules: [{ required: true, message: 'Title is required' }],
  },
  SUBTITLE: {
    name: 'subtitle',
    label: 'Gallery subtitle:',
    placeholder: 'Enter a subtitle for the gallery',
    rules: [{ required: true, message: 'A subtitle is required' }],
  },
};

export const IMAGE_INITS = {
  [FORM_FIELD.TITLE.name]: '',
  [FORM_FIELD.SUBTITLE.name]: '',
  images: [],
};

export const INITIAL_VALUES = {
  [FORM_FIELD.IMAGES.name]: [],
  [FORM_FIELD.BACKGROUND_COLOR.name]: FORM_FIELD.BACKGROUND_COLOR.colors[0],
  [FORM_FIELD.TEXT_COLOR.name]: FORM_FIELD.TEXT_COLOR.colors[0],
};
